export default "__VITE_ASSET__Ct4R6iFB__"